var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLines2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1700,
    height: 561,
    viewBox: "0 0 1700 561",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M850 -450.606C1318.85 -450.606 1699 -89.7688 1699 355.268C1699 800.305 1318.85 1161.14 850 1161.14C381.147 1161.14 1 800.305 1 355.268C1 -89.7688 381.147 -450.606 850 -450.606Z",
    stroke: "#FFEF00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.14 772.6C1356.01 772.6 1631.85 512.167 1631.85 193.105C1631.85 -125.956 1356.01 -386.864 1018.14 -386.864C680.274 -386.864 403.915 -126.431 403.915 193.129C403.915 512.688 679.721 772.624 1018.14 772.624V772.6Z",
    stroke: "#00A8E1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.702 1097.4C1022.61 1097.4 1299.28 836.968 1299.28 517.906C1299.28 198.845 1022.63 -62.0868 683.702 -62.0868C344.774 -62.0868 68.1499 198.371 68.1499 517.906C68.1499 837.442 344.27 1097.4 683.727 1097.4H683.702Z",
    stroke: "#FF5C00",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines2);
export default __webpack_public_path__ + "static/media/lines2.2c8ef3dd6b121ea10b1b24ab782ae4ce.svg";
export { ForwardRef as ReactComponent };